<!-- Quill Editor Toolbar -->
<div #editor class="quill-editor"></div>

<!-- Display the raw formatted HTML content -->
<!--<div class="content-preview">-->
<!--  <h3>Formatted Content (HTML)</h3>-->
<!--  <div [innerHTML]="content"></div>-->
<!--</div>-->
